import { render } from "./VideoGallery.vue?vue&type=template&id=53d08b58&bindings={\"videos\":\"props\",\"setVideo\":\"options\",\"geturl\":\"options\"}"
import script from "./VideoGallery.vue?vue&type=script&lang=js"
export * from "./VideoGallery.vue?vue&type=script&lang=js"
script.render = render

export default script